module.exports = __webpack_public_path__ + "img/Business_item_2.3f069eea.jpg";